import ClassModel from "#src/models/ClassModel.ts";
import CouponModel from "#src/models/CouponModel.ts";
import GroupRegistrationModel, {
  isGroupRegistration,
} from "#src/models/GroupRegistrationModel.ts";
import MembershipModel, { isMembership } from "#src/models/MembershipModel.ts";
import MembershipOfferingModel from "#src/models/MembershipOfferingModel.ts";
import { checkCouponData } from "#src/utils/checkCouponData.ts";
import { moment } from "#src/utils/dateTime.ts";
import {
  AmountType,
  coupons,
  Frequency,
  GroupRegistrationStatus,
} from "#types/code-generator.ts";

interface CalculateCouponsForInvoiceItemInput {
  coupons: coupons["coupons"];
  registration: GroupRegistrationModel | MembershipModel;
  startDate: Date;
  chargeAmount: number;
}

export function calculateCouponsForCharge({
  coupons,
  registration,
  startDate,
  chargeAmount,
}: CalculateCouponsForInvoiceItemInput) {
  const result: Array<{
    coupon: CouponModel;
    amount: number;
  }> = [];

  const activeCoupons = coupons.filter((c) =>
    checkCouponData({
      coupon: c,
    })
  );

  // console.log("activeCoupons", activeCoupons);

  let offering: ClassModel | MembershipOfferingModel =
    isGroupRegistration(registration) && registration.class;

  if (isMembership(registration)) {
    offering = registration.offering;
  }

  const price = chargeAmount;

  activeCoupons.forEach((coupon) => {
    let amount = 0;

    if (
      coupon.availableForAllOfferings ||
      (offering.coupons &&
        offering.coupons.find((ocoupon) => ocoupon.id === coupon.id))
    ) {
      if (coupon.amountType === AmountType.Dollar) {
        amount += coupon.amount;
      } else {
        amount += price * (coupon.amount / 100);
      }

      if (
        registration.status === GroupRegistrationStatus.Waitlist &&
        moment().isSame(startDate, "day")
      ) {
        amount = 0;
      }

      if (
        coupon.frequency === Frequency.OneTime &&
        moment().isBefore(startDate, "day")
      ) {
        amount = 0;
      }

      if (
        coupon.frequency === Frequency.Monthly &&
        coupon.applyAtCheckout === false
      ) {
        amount = 0;
      }

      if (amount >= price) {
        amount = price;
      }

      if (!Number.isInteger(amount)) {
        amount = Math.floor(amount);
      }

      result.push({ coupon, amount });
    }
  });

  // console.log("result", result);

  return result;
}
